import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import Layout from "../../components/Layout.js";
import "../../assets/styles/pages/Relatorio/PowerBI.scss";
import "../../assets/styles/pages/Processo/Detalhes.scss";
import Geral from "../../components/Relatorios/Abas/Geral.js";
import Assistente from "../../components/Relatorios/Abas/Assistente.js";
import Enfermeira from "../../components/Relatorios/Abas/Enfermeira.js";
import Operadora from "../../components/Relatorios/Abas/Operadora.js";

export default function DesempenhoOperacional() {
  const location = useLocation();
  const hash = location.hash?.replace("#", "");
  const [abas] = useState([
    {
      "id": "geral",
      "nome": "Geral",
      "alertas": 0,
      "ordem": "1",
    },
    {
      "id": "assistente",
      "nome": "Por assistente",
      "alertas": 0,
      "ordem": "2",
    },
    {
      "id": "enfermeira",
      "nome": "Por enfermeira",
      "alertas": 0,
      "ordem": "3",
    },
    {
      "id": "operadora",
      "nome": "Por operadora",
      "alertas": 0,
      "ordem": "4",
    },
  ]);

  const [aba, setAba] = useState(
    [
      "geral",
      "assistente",
      "enfermeira",
      "operadora"
    ].includes(hash)
      ? hash
      : "geral"
  );

  const abaActive = () => {
    // let abaAtual = abas.find((aba_item) => aba_item.id === aba) || {};

    switch (aba) {
      case "assistente":
        return (
          <Assistente
            className="f600-18 mh-20 mt-20 mb-30"
          />
        );
      case "enfermeira":
        return (
          <Enfermeira
            className="f600-18 mh-20 mt-20 mb-30"
          />
        );
      case "operadora":
        return (
          <Operadora
            className="f600-18 mh-20 mt-20 mb-30"
          />
        );
      default:
        return (
          <Geral
            className="f600-18 mh-20 mt-20 mb-30"
          />
        );
    }
  };

  return (
    <Layout className="view-listagem">
      <div className="flex jc-sb ai-fc gap-30 w-100 mb-30">
        <div>
          <p className="page-title">Relatórios</p>
          <h2 className="title black-text">
            Desempenho Operacional
          </h2>
        </div>
      </div>
      <div className="flex jc-sb ai-fc mt-30" id="detalhes">
        <ul className="abas gap-5">
          {(abas || []).map((row_aba) => {
            return (
              <li
                className={`f400-16 ${aba === row_aba.id ? "active" : ""}`}
                key={row_aba.id}
                onClick={() => setAba(row_aba.id)}
              >
                {row_aba.nome}
                {row_aba.alertas > 0 && (
                  <span className="f700-12">{row_aba.alertas}</span>
                )}
              </li>
            );
          })}
        </ul>
      </div>
      {abaActive()}
    </Layout >
  );
}